export default {
      id: "filter-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#filter",
      toString: function () {
        return this.url;
      }
    }